import React, { useEffect,useState } from 'react'
import { useParams } from 'react-router-dom'
import { Grid2,Typography } from '@mui/material'
import { productsData } from '../../../utils/constants'
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import "../ProductPage.css"
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PersonIcon from '@mui/icons-material/Person';


export function ProductPageDesktop() {  
  const {productName,category,id}=useParams()
  const [productData,setproductData]=useState()

  const [value, setValue] =useState();
  
  useEffect(()=>{
    const data=productsData?.find((item,i)=>{if(i==id){return(item)}} )
    setproductData(data)
  },[id])

  function handleClick(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
  }

  return (
  <Grid2 container className="product-page-container">
      <Grid2 container className="product-data-container">
        <Grid2 className="product-image-container">
          {productData && <img  src={require(`../../../assets/Products/${productData?.image}.jpg`)} alt="" />}
        </Grid2>
        <Grid2 className="product-info-container">
            <Breadcrumbs separator="›" aria-label="breadcrumb">
              <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick} sx={{display:"flex",justifyContent:"center",alignItems:"center",fontSize:"16px !important"}}>  <HomeIcon align="center" sx={{fontSize:"18px"}}/> Home</Link>
              <Link underline="hover" key="2" color="inherit" href="/" onClick={handleClick} sx={{fontSize:"16px !important"}}>Products</Link>
              <Link underline="hover" key="3" color="inherit" href="/"  onClick={handleClick} sx={{fontSize:"16px !important"}}>{category}</Link>
              <Link underline="hover" key="4" color="inherit" href="/"  onClick={handleClick} sx={{fontSize:"16px !important"}}>{productName}</Link>
            </Breadcrumbs>
            <Typography className="product-category">{category.toUpperCase()}</Typography>
            <Typography className="product-name">{productName}</Typography>
            <Grid2 container gap="10px" className="product-price">
              <Typography className="itemprice" variant='h5'><CurrencyRupeeIcon sx={{fontSize:"18px"}} />{productData?.price}<span style={{fontSize:"12px", fontWeight:"500 !important"}}>M.R.P</span></Typography>
              <Typography className="itemprice" variant='h5' sx={{color:"gray !important", fontSize:"18px !important", fontWeight:"500 !important", textDecoration:"line-through"}}><CurrencyRupeeIcon sx={{fontSize:"13px",color:"gray"}} />{productData?.prevPrice}</Typography>
            </Grid2>
            <Grid2 className="product-rating">
              {productData?.rating>=1? <StarIcon sx={{fontSize:"25px"}}/>:productData?.rating>=0.5? <StarHalfIcon sx={{fontSize:"25px"}}/>:<StarBorderIcon sx={{fontSize:"25px"}}/>}
              {productData?.rating>=2? <StarIcon sx={{fontSize:"25px"}}/>:productData?.rating>=1.5? <StarHalfIcon sx={{fontSize:"25px"}}/>:<StarBorderIcon sx={{fontSize:"25px"}}/>}
              {productData?.rating>=4? <StarIcon sx={{fontSize:"25px"}}/>:productData?.rating>=3.5? <StarHalfIcon sx={{fontSize:"25px"}}/>:<StarBorderIcon sx={{fontSize:"25px"}}/>}
              {productData?.rating>=3? <StarIcon sx={{fontSize:"25px"}}/>:productData?.rating>=2.5? <StarHalfIcon sx={{fontSize:"25px"}}/>:<StarBorderIcon sx={{fontSize:"25px"}}/>}
              {productData?.rating>=5? <StarIcon sx={{fontSize:"25px"}}/>:productData?.rating>=4.5? <StarHalfIcon sx={{fontSize:"25px"}}/>:<StarBorderIcon sx={{fontSize:"25px"}}/>}
              <Typography sx={{color:"#444",fontSize:"14px"}}>({productData?.rating})</Typography>
              <Typography sx={{color:"#444",display:"flex",justifyContent:"center",fontSize:"16px"}}><PersonIcon sx={{color:"#154A72",fontSize:"20px"}}/>({productData?.noofreviews})</Typography>
            </Grid2>
          </Grid2>
        </Grid2>
  </Grid2>
  )
}

 